import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';
export default function NewsletterSection() {
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const handleSubmit = (e) => {
        e.preventDefault();
        if (!email)
            return;
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setSubmitted(true);
        }, 1200);
    };
    return (<section id="newsletter" className="bg-background border-t border-border/40 py-12 lg:py-14" aria-label="Newsletter subscription">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center gap-6 md:gap-10">
          {/* Icon + Text */}
          <div className="flex items-center gap-4 shrink-0">
            <div className="w-14 h-14 rounded-full bg-primary/15 border border-primary/30 flex items-center justify-center shrink-0">
              <Icon name="EnvelopeIcon" size={24} className="text-primary"/>
            </div>
            <div>
              <h3 className="font-display text-xl font-semibold text-foreground">Stay Updated</h3>
              <p className="text-muted-foreground text-sm mt-0.5 max-w-xs">
                Subscribe to get the latest event updates and special offers.
              </p>
            </div>
          </div>

          {/* Form */}
          <div className="flex-1 w-full max-w-xl">
            {submitted ? (<div className="flex items-center gap-3 p-4 rounded-xl bg-primary/10 border border-primary/30">
                <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center shrink-0">
                  <Icon name="CheckIcon" size={16} className="text-primary"/>
                </div>
                <div>
                  <p className="text-foreground font-semibold text-sm">You&apos;re subscribed!</p>
                  <p className="text-muted-foreground text-xs">We&apos;ll keep you updated on upcoming events.</p>
                </div>
              </div>) : (<form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter your email address" required className="input-gold flex-1 px-5 py-3.5 rounded-full text-sm" aria-label="Email address"/>
                <button type="submit" disabled={loading} className="btn-gold flex items-center justify-center gap-2 px-7 py-3.5 rounded-full text-sm font-bold tracking-widest uppercase shrink-0 disabled:opacity-70">
                  {loading ? (<Icon name="ArrowPathIcon" size={16} className="animate-spin text-black"/>) : (<span>Subscribe</span>)}
                </button>
              </form>)}
          </div>
        </div>
      </div>
    </section>);
}
